import { AlertLayerUrlContext } from "context/alertLayerUrlContext";

import { CurrentUserContext } from "context/currentUserContext";

import { RoleContext } from "context/roleContext";
import { useContext, useEffect, useState } from "react";

export function useAlertLayerUrl() {
    const [alertLayerUrl, setAlertLayerUrl] = useState<string>("");

    const alertLayerUrlContext = useContext(AlertLayerUrlContext);
    const roleContext = useContext(RoleContext);
    const currentUserContext = useContext(CurrentUserContext);
    // Removed obsolete CouncilTokenContext usage

    useEffect(() => {
        if (!roleContext.roles || !currentUserContext.currentUser) return;

        if (
            roleContext.roles.isSysAdmin ||
            roleContext.roles.isCouncilUser
        ) {
            // Removed obsolete CouncilTokenContext fetch
        }
    }, [roleContext.roles, currentUserContext.currentUser]);

    useEffect(() => {
        setAlertLayerUrl(
            `${alertLayerUrlContext.alertLayerDetails?.url}`
        );

    }, [
        alertLayerUrlContext.alertLayerDetails,
        // Removed obsolete CouncilTokenContext mapInformation
    ]);

    return alertLayerUrl;
}
